module.exports = __webpack_public_path__ + "static/media/z&v9.63bdc0a9.jpg";